import * as React from 'react';
export const IcPeriodProblems = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14.62 16.4a5.47 5.47 0 010-7.77l.63-.63H6V6a1 1 0 011-1h1.28a2 2 0 00.72.73A2 2 0 0010 6h4a2 2 0 001-.27 2 2 0 00.72-.73H17a1 1 0 011 1 2.73 2.73 0 01.5 0 3 3 0 011.5.41V6a3 3 0 00-3-3h-1.28a2 2 0 00-.72-.73A2 2 0 0014 2h-4a2 2 0 00-1 .27 2 2 0 00-.72.73H7a3 3 0 00-3 3v13a3 3 0 003 3h10a3 3 0 003-3v-1.23a5.34 5.34 0 01-1.5.23 5.45 5.45 0 01-3.88-1.6zM21 10.05l-1.79-1.76a1 1 0 00-1.42 0L16 10.05A3.481 3.481 0 0016 15a3.51 3.51 0 005 0 3.4 3.4 0 001-2.46 3.46 3.46 0 00-1-2.49z'
      fill='currentColor'
    />
  </svg>
);
